import React, { useEffect } from 'react';
import Button from '@mui/material/Button';

const ProjectInfo = ({ project, generateLink, copied }) => {

    return (
      <div className="divCurrentTerritory" style={{padding: '10px', fontSize: '14px'}}>
        <label style={{ color: '#d1d1d1', textShadow: '2px 2px 4px rgba(0, 0, 0, 1)'}}>Проект</label>
        <hr style={{margin: '0px'}}/>
        <label style={{ color: 'white', textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>ID: <span style={{ color: '#fcc205',textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>{project.id}</span></label>
        <br/>
        <label style={{ color: 'white', textShadow: '2px 2px 4px #000000ff' }}>
          Название:{" "}
          <span style={{ color: '#ffcc26ff', textShadow: '2px 2px 4px #000000ff' }}>
            {project.name.match(/.{1,18}/g)?.map((chunk, index) => (
              <React.Fragment key={index}>
                {chunk}
                <br />
              </React.Fragment>
            ))}
          </span>
        </label>  
        <br/>
        <label style={{ color: 'white', textShadow: '2px 2px 4px #000000ff' }}>Округ: <span style={{ color: '#fcc205',textShadow: '2px 2px 4px #000000ff' }}>{project.canton}</span></label>
        <br/>
        <label style={{ color: 'white', textShadow: '2px 2px 4px #000000ff' }}>Регион: <span style={{ color: '#fcc205',textShadow: '2px 2px 4px #000000ff' }}>{project.region}</span></label>
        <br/>
        <label style={{ color: 'white', textShadow: '2px 2px 4px #000000ff' }}>Создал: <span style={{ color: '#fcc205',textShadow: '2px 2px 4px #000000ff' }}>{project.authorId}</span></label>
         <hr style={{marginTop: '5px', marginBottom: '5px'}}/>
          <button className={`copyBtn ${copied ? "copied" : ""}`} onClick={generateLink}>
            {copied ? "✓ Скопировано" : "Копировать ссылку"}
          </button>
       
      </div>
      
    );
  
}

export default ProjectInfo;